import { Vector2 } from "three";
import { Vector3 } from "three";
import { Vector4 } from "three";
import { CoreType } from "../Type";
import { AttribSize } from "./Constant";
export var Attribute = /* @__PURE__ */ ((Attribute2) => {
  Attribute2["POINT_INDEX"] = "ptnum";
  Attribute2["OBJECT_INDEX"] = "objnum";
  Attribute2["COLOR"] = "color";
  Attribute2["NORMAL"] = "normal";
  Attribute2["POSITION"] = "position";
  Attribute2["PSCALE"] = "pscale";
  Attribute2["UP"] = "up";
  Attribute2["UV"] = "uv";
  Attribute2["SCALE"] = "scale";
  Attribute2["TANGENT"] = "tangent";
  return Attribute2;
})(Attribute || {});
export var ObjectAttribute = /* @__PURE__ */ ((ObjectAttribute2) => {
  ObjectAttribute2["HOVERED"] = "hovered";
  return ObjectAttribute2;
})(ObjectAttribute || {});
const ATTRIB_NAME_MAP = {
  P: "position" /* POSITION */,
  N: "normal" /* NORMAL */,
  Cd: "color" /* COLOR */
};
export class CoreAttribute {
  static remapName(name) {
    return ATTRIB_NAME_MAP[name] || name;
  }
  static arrayToIndexedArrays(array) {
    const index_by_value = {};
    let current_index = 0;
    const indices = [];
    const values = [];
    let i = 0;
    while (i < array.length) {
      const value = array[i];
      const index = index_by_value[value];
      if (index != null) {
        indices.push(index);
      } else {
        values.push(value);
        indices.push(current_index);
        index_by_value[value] = current_index;
        current_index += 1;
      }
      i++;
    }
    return {
      indices,
      values
    };
  }
  static default_value(size) {
    switch (size) {
      case 1:
        return 0;
      case 2:
        return new Vector2(0, 0);
      case 3:
        return new Vector3(0, 0, 0);
      default:
        throw `size ${size} not yet implemented`;
    }
  }
  static copy(src, dest, mark_as_needs_update = true) {
    const src_array = src == null ? void 0 : src.array;
    const dest_array = dest == null ? void 0 : dest.array;
    if (src_array && dest_array) {
      const min_length = Math.min(src_array.length, dest_array.length);
      for (let i = 0; i < min_length; i++) {
        dest_array[i] = src_array[i];
      }
      if (mark_as_needs_update) {
        dest.needsUpdate = true;
      }
    }
  }
  static attribSizeFromValue(val) {
    if (CoreType.isString(val) || CoreType.isNumber(val)) {
      return AttribSize.FLOAT;
    }
    if (CoreType.isArray(val)) {
      return val.length;
    }
    switch (val.constructor) {
      case Vector2:
        return AttribSize.VECTOR2;
      case Vector3:
        return AttribSize.VECTOR3;
      case Vector4:
        return AttribSize.VECTOR4;
    }
    return 0;
  }
}
